import { ScriptBlock } from '../types';

/**
 * Interpolates missing sceneIds in script blocks by inheriting from
 * the nearest previous block that has a sceneId assigned.
 *
 * This ensures every block has a sceneId for grouping/display logic,
 * even if the AI extraction missed some assignments.
 *
 * @param blocks - Array of script blocks sorted by pageNumber → blockIndex
 * @returns Array of blocks with interpolated sceneIds
 */
export function interpolateSceneIds(blocks: ScriptBlock[]): ScriptBlock[] {
    if (blocks.length === 0) return blocks;

    const result: ScriptBlock[] = [];
    let currentSceneId: string | null = null;

    for (const block of blocks) {
        if (block.sceneId) {
            currentSceneId = block.sceneId;
            result.push(block);
        } else {
            result.push({
                ...block,
                sceneId: currentSceneId,
            });
        }
    }

    return result;
}
